import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/marketplace';

const HomeRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/Marketplace')),
    name: 'Market Place',
};

export default HomeRoute;
